import { supabase } from './supabaseClient'

const SHEETS_URL =
  'https://script.google.com/macros/s/AKfycbzRn7EMdGrGew2qjXkk9RfGUEyxnCSwfc47wdAiQs51gQCtWOU8vVb88MuH8UoTahPe/exec'

const EDGE_FN_URL =
  'https://wxmnusopoqcqxmchvdjd.supabase.co/functions/v1/export-to-sheets'

const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind4bW51c29wb3FjcXhtY2h2ZGpkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI0MTc0MjksImV4cCI6MjA5Nzk5MzQyOX0.s0IuuWRaSNBIEcvwc9_mxTB1FpfgZ3ekrJhfKlX3ZQA'

function sheetsISupabase(eilute) {
  return {
    pavadinimas: eilute['Pavadinimas'],
    kategorija: (eilute['Kategorija'] || '').toLowerCase(),
    regionas: eilute['Regionas'] || null,
    latitude: parseFloat(eilute['Latitude']) || null,
    longitude: parseFloat(eilute['Longitude']) || null,
    aprasymas: eilute['Aprašymas'] || null,
    tinka_vaikams: eilute['Tinka vaikams?'] === 'Taip',
    nemokama: eilute['Nemokama?'] === 'Taip',
    darbo_laikas: eilute['Darbo laikas'] || null,
    nuotrauka_url: eilute['Nuotraukos URL'] || null,
    miestas: eilute['Miestas'] || null,
  }
}

// Eksportas: Supabase → Sheets per Edge Function
export async function exportToSheets() {
  const res = await fetch(EDGE_FN_URL, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
    },
  })
  if (!res.ok) {
    const txt = await res.text()
    throw new Error(`Edge Function klaida (${res.status}): ${txt}`)
  }
  return await res.json()
}

// Importas: Sheets → Supabase
// Importuoja "✅ Apdorota" statusą turinčias eilutes
// Po sėkmingo importo pakeičia statusą į "aktyvus"
export async function importFromSheets() {
  // 1. Gaunam visas eilutes iš Sheets
  const res = await fetch(`${SHEETS_URL}?action=getAll`)
  if (!res.ok) throw new Error(`Sheets nepasiekiamas (${res.status})`)
  const eilutes = await res.json()
  if (!Array.isArray(eilutes)) throw new Error('Sheets grąžino netinkamą formatą')

  // 2. Filtruojam tik "✅ Apdorota" su reikalingais laukais
  const naujos = eilutes.filter(
    (e) =>
      e['Statusas'] === '✅ Apdorota' &&
      e['Pavadinimas'] &&
      parseFloat(e['Latitude']) &&
      parseFloat(e['Longitude'])
  )

  if (naujos.length === 0) {
    return { importuota: 0, praleista: eilutes.length }
  }

  // 3. Importuojam į Supabase
  const vietos = naujos.map(sheetsISupabase)
  const { data, error } = await supabase.from('vietos').insert(vietos).select()

  if (error) throw error

  // 4. Atnaujinam statusą į "aktyvus" Sheets'uose
  // Siunčiam POST užklausą į Apps Script
  const pavadinimaiImportuoti = data.map(v => v.pavadinimas)

  const updateRes = await fetch(SHEETS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      action: 'updateStatus',
      pavadinimai: pavadinimaiImportuoti,
      statusas: 'aktyvus'
    })
  })

  if (!updateRes.ok) {
    console.warn('Statusų atnaujinimas nepavyko, bet importas sėkmingas')
  }

  return { importuota: data.length, praleista: eilutes.length - naujos.length }
}
